import { atom, useSetAtom, useAtomValue } from 'jotai'
import { useCallback } from 'react'

export type ChatToast = {
  id: number
  title?: string | React.ReactElement
  message?: string | React.ReactElement
  type?: 'default' | 'success' | 'warning' | 'error'
  duration?: number
}

let toastId = 1
const chatToastsAtom = atom<ChatToast[]>([])
export const useChatToasts = () => useAtomValue(chatToastsAtom)

export const useAddChatToast = () => {
  const setChatToasts = useSetAtom(chatToastsAtom)
  return useCallback(
    (toast: Omit<ChatToast, 'id'>) => {
      const t = { ...toast, id: toastId++ }
      setChatToasts((prev) => [...prev, t])
    },
    [setChatToasts],
  )
}

export const useRemoveChatToast = () => {
  const setChatToasts = useSetAtom(chatToastsAtom)
  return useCallback(
    (toastId: number) => {
      setChatToasts((prev) => prev.filter((t) => t.id !== toastId))
    },
    [setChatToasts],
  )
}
